const Contact = () => {
    return (
        <div>
            <h3>Want to know more? Here are some links for that!</h3>
            <footer>
                <div className="socials">
                    <p>Email: <a href="mailto:onni.alasaari@gmail.com">onni.alasaari@gmail.com</a></p>
                    <p>More of my work is visible on my <a href="https://github.com/Higic" target="_blank" rel="noreferrer">GitHub</a> page.</p>
                    <p>You can also contact me via <a href="https://www.linkedin.com/in/onni-alasaari-626339272/" target="_blank" rel="noreferrer">LinkedIn</a>!</p>
                </div>

                    <p><b>Developed in React, made by Onni Alasaari, 2024, source code can be found <a href="https://github.com/Higic/portfolio/tree/master/portfolio">here</a></b></p>
            </footer>
        </div>
    );
}

export default Contact;